export default __webpack_public_path__ + "static/media/biodiversidade.8f509ae5.svg";